import { createFileRoute } from '@tanstack/react-router';
import { ResultsMain } from '@/components';

export const Route = createFileRoute('/results/')({
  component: ResultsMain,
});
